import httpService from '../../../../services/httpService';

const getOffsetTime = () => {
  const offset = new Date().getTimezoneOffset();
  const sign = offset > 0 ? '-' : '+';
  const abs = Math.abs(offset);
  return `${sign}${String(Math.floor(abs / 60)).padStart(2, '0')}:${String(abs % 60).padStart(2, '0')}`;
};

const PortfolioClient = {
  /**
   * Fetch the paginated list of applicants (reuses existing /interview_admin/users)
   */
  list: async (params?: {
    page_number?: number;
    limit?: number;
    name?: string;
    email?: string;
    status?: string;
    job_categories?: string;
    job_opportunity_id?: string;
    assigned_to?: string;
  }) => {
    const response = await httpService.get('/interview_admin/users', { params });
    return response.data;
  },

  /**
   * Fetch portfolio groups for 2-level view
   */
  getGroups: async (params: {
    group_by: 'status' | 'job_category' | 'assigned_to';
    name?: string;
    status?: string;
    job_categories?: string;
    job_opportunity_id?: string;
    assigned_to?: string;
  }) => {
    const response = await httpService.get('/portfolio/groups', { params });
    return response.data;
  },

  /**
   * Fetch the full portfolio for a single candidate:
   * profile + interviews[] + job_searches[]
   */
  getPortfolio: async (userId: string) => {
    const response = await httpService.get(
      `/interview_admin/portfolio/${encodeURIComponent(userId)}`
    );
    return response.data;
  },

  /**
   * Fetch interview feedback using the existing feedback endpoint
   */
  getFeedback: async (sessionId: string, candidateId: string) => {
    const response = await httpService.get('/interview/feedback', {
      params: { session_id: sessionId, candidate_id: candidateId },
    });
    return response.data;
  },

  /**
   * Fetch all sessions for a candidate (for additional timeline data if needed)
   */
  getCandidateSessions: async (candidateId: string) => {
    const response = await httpService.get('/interview/sessions', {
      params: { candidate_id: candidateId, offset_time: getOffsetTime() },
    });
    return response.data;
  },

  /**
   * Fetch all admin users (super admin + sub-admins) for the current company.
   * Used to populate the "Assigned To" dropdown.
   */
  getAdminUsers: async (params?: { page_number?: number; limit?: number }) => {
    const response = await httpService.get('/interview_admin/admin_user/list', {
      params: { page_number: 1, limit: 100, ...params },
    });
    return response.data;
  },
};

export default PortfolioClient;
